import React from "react";
import { Card, Modal, Button, message, Divider, Flex, Tag, Space } from "antd";
import { 
  PhoneOutlined, 
  ShoppingOutlined,
  NotificationOutlined,
  StopOutlined,
  ArrowRightOutlined,
  BarcodeOutlined,
  HighlightOutlined,
  PayCircleOutlined,
  DoubleRightOutlined
} from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import dayjs from "dayjs";
import { detectSys } from "../../utils/device";
import { safeCall } from "../../utils/webview";
import { PayFlow, TwoStepFlow } from "./flow";
import Remarks from "./remarks";

const { Meta } = Card;

const OrderCard = (props) => {
  const { onFlowChange = () => {}, content: order, showActions = true, ...others } = props;

  if (!order) return null;

  let {
    orderNo,
    thirdOrderNo,
    orderStatus,
    updateTime,
    fromShop,
    quantity,
    createTime,
    payStatus,
    goodsType,
    refundStatus,
    amount,
    shouldAmount,
    realAmount,
    city,
    county,
    sellerRemark,
    goodsId,
    appointment = {},
    shop,
    shopId,
    orderId,
    customer,
    from,
    groupId,
    unit,
    meta: goods,
    shareCustomer,
    pays = [{ amount: 0 }],
    shareShop,
  } = order;

  console.log("shareCustomer", shareCustomer);
  // 根据pays计算真实支付
  const realPayAmount = pays.reduce((total, pay) => {
    total += pay.amount;
    return total;
  }, 0);

  const fullAddrass = `${(appointment || goods?.appointmentInfo)?.province || ""}${(appointment || goods?.appointmentInfo)?.city || ""}${(appointment || goods?.appointmentInfo)?.county || ""}${(appointment || goods?.appointmentInfo)?.community || ""}${(appointment || goods?.appointmentInfo)?.address || ""}`;

  const actions = showActions ? [
    <a href={`/order/detail?shopId=${shopId}&orderId=${orderId}`}>详情<ArrowRightOutlined key="详情" /></a>
  ] : [];
  // 特殊订单打标
  const tags = [];
  // 手工订单
  from = from ? from : "线下";
  tags.push(<Tag key={from} color="blue">{from}</Tag>);

  if(groupId) tags.push(<Tag color="cyan">团购</Tag>);

  if (payStatus === 0 && orderStatus === 0 && window.__baseInfo.isSuper) {
    actions.unshift(<span onClick={() => onPayCancel(orderId, shopId)}><StopOutlined  /> 取消</span>);
  }

  if (orderStatus < 12 && goodsType !== "TIMES_CARD") {
    actions.unshift(<span><BarcodeOutlined /> <PayFlow order={order}  /></span>);
  }

  // 订单取消
  if (orderStatus === 14) {
    tags.push(<Tag key={orderStatus} color="orange">已取消</Tag>);
  } else if (payStatus === 0) {
    tags.push(<Tag color="orange" key={payStatus}>待支付</Tag>);
  }

  if (refundStatus === 3) {
    tags.push(<Tag key={refundStatus} color="orange">退款中</Tag>);
    // actions.unshift(<span onClick={() => onPayClick(orderNo, 0)}><BarcodeOutlined /> 同意退款</span>);
  } else if (refundStatus === 6) {
    tags.push(<Tag key={refundStatus} color="orange">已退款</Tag>);
  }

  if (goodsType === "TIMES_CARD") {
    tags.push(<Tag key={goodsType} color="cyan">次卡</Tag>);
  }

  // console.log(items);
  let title = <>
    {tags}
    <span style={{ fontSize: "14px" }}>{(appointment || goods?.appointmentInfo)?.customerName}-{(appointment || goods?.appointmentInfo)?.county}</span>
    {/* <a href={`/order-list-als?phoneNo=${phoneNo}`} style={{ padding: "0px 5px", fontSize: "12px", fontWeight: "400" }}>历史订单</a> */}
  </>;
  // 据现在多少小时
  let hours = ((Date.now() - dayjs(createTime)) / 3600 / 1000).toFixed(1);
  hours = <span style={{ color: hours > 24 ? "red" : "#000", fontWeight: "bold" }}>{hours}小时</span>;

  const onPayCancel = async (orderId, shopId) => {
    Modal.confirm({
      title: "取消订单",
      content: "确定要取消该订单吗？",
      onOk: async () => {
        let response = await fetch("/api/order/cancel", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId,
            shopId,
          }),
        });

        let result = await response.json();

        if (result.success) {
          message.info("订单已取消！");
          onFlowChange();
        } else {
          message.error(result.data);
        }
      },
    });
  };

  const updateOrder = async (remark, orderId, shopId) => {
    const m = Modal.info({
      icon: null,
      closable: true,
      title: "确定完成收款？请备注原因",
      content: <Remarks remark={remark} orderId={orderId} shopId={shopId} prefix={"完成收款"} orderData={{ payStatus: 2 }} onChange={() => {
        m.destroy();
        onFlowChange();
      }} />,
      footer: null,
    });
  };

  const viewRemark = (remark, orderId, shopId) => {
    const m = Modal.info({
      icon: null,
      closable: true,
      title: "订单备注",
      content: <Remarks remark={remark} orderId={orderId} shopId={shopId} onChange={() => {
        m.destroy();
        onFlowChange();
      }} />,
      footer: null,
    });
  };

  return (
    <Card
      key={orderNo}
      style={{
        // width: 300,
        maxWidth: "600px",
        margin: "10px auto 0",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      actions={actions}
      {...others}
    >
      <Meta
        // avatar={<Avatar src={imageUrl} />}
        title={title}
        // description={`${city}${county}${area ? area : ''}${address}`}
      />
      <ul style={{ fontSize: "12px", listStyle: "none", padding: 0 }}>
        <li>
          订单号：{orderNo}&nbsp;{thirdOrderNo && <>({thirdOrderNo})</>}
        </li>
        <li style={{ fontWeight: "bold", color: "green", textDecoration: "underline" }}>
          预约时间：{(appointment || goods?.appointmentInfo)?.appointmentTime ? dayjs((appointment || goods?.appointmentInfo)?.appointmentTime).format("YYYY-MM-DD HH:mm") : "未预约"}
        </li>
        <li>
          客户电话：{(appointment || goods?.appointmentInfo)?.phoneNo} 
          &nbsp; 
          <a onClick={() => safeCall((appointment || goods?.appointmentInfo)?.phoneNo)} style={{padding: '0 5px'}}><PhoneOutlined /></a>
          &nbsp;
          <a href={`/order?shopId=${shopId}&phoneNo=${(appointment || goods?.appointmentInfo)?.phoneNo}`}>历史订单</a>
        </li>
        <li>
          客户地址：{fullAddrass || "无"}
          &nbsp;
          <CopyToClipboard text={fullAddrass} onCopy={() => message.success("复制成功")}>
            <a size="small" style={{ fontSize: "12px" }}>复制</a>
          </CopyToClipboard>
          {/* &nbsp;
          {
            detectSys() === "iOS" 
            ? <a href={`iosamap://poi?sourceApplication=yxdj&poiname=${appointment.address}&city=${appointment.city}&dev=0`}>高德导航</a>
            : <a href={`androidamap://poi?sourceApplication=yxdj&poiname=${appointment.address}&city=${appointment.city}&dev=0`}>高德导航</a>
          } */}
          
        </li>
        <li>
          <Divider size="small" style={{ margin: "5px" }} />
        </li>
        <li>
          <ShoppingOutlined style={{ color: "green" }} />&nbsp;
          <span>{goods?.goodsInfo?.title}{goods?.skuId && <span>-{goods?.skuList.filter(i => i.skuId === goods.skuId)?.[0]?.title}</span>}&nbsp;
          <span style={{ color: "red" }}> x {quantity}</span>{unit ? unit : null}</span>
          {realPayAmount ? <span>；单价：<span style={{ color: "red" }}>{((realPayAmount) / quantity / 100).toFixed(2)}</span>元</span> : null}
        </li>
        <li>
          <Flex gap={20}>
            <div>服务店铺：{fromShop.title}</div>

            <div>下单店铺：{shop.title}</div>
          </Flex>
        </li>
        <li>
          {<span>下单时间：{new Date(createTime).toLocaleString()}</span>}
          {![12, 14].includes(orderStatus) && <>(已下单{hours})</>}
        </li>
        {/* { window.__userRole === 'admin' && <li>更新时间：{new Date(updateTime || createTime).toLocaleDateString()} {new Date(updateTime || createTime).toLocaleTimeString()}</li>} */}
        {/* {
          orderStatus === 12 && <li>
            完成日期：{new Date(updateTime).toLocaleString()}
            (耗时{((dayjs(updateTime) - dayjs(createTime)) / 1000 / 3600).toFixed(1)}小时)
          </li>
        } */}
        {
          <li>
            <Space>
              <span>分销员：{shareCustomer?.username || "无"}{shareCustomer?.customerId && <span>({shareCustomer.customerId})</span>}</span>
              <span>导购员：{shareShop?.title || "无"}</span>
            </Space>
          </li>
        }

        {<li>
          <Flex style={{ whiteSpace: "nowrap" }}>
            <div>
              <HighlightOutlined style={{ color: "orange" }} /> 备注(<b style={{ color: "orange" }}>{sellerRemark?.split("$$")?.length || 0}</b>条)：
            </div>

            <span style={{ textDecoration: "underline orange", overflow: "hidden", textOverflow: "ellipsis", marginRight: "6px" }}>{sellerRemark?.split("$$")[0]}</span>

            <Space style={{ marginLeft: "auto" }}>
              <a onClick={() => viewRemark(sellerRemark, orderId, shopId)}>
                查看/添加
              </a>
            </Space>
          </Flex>
        </li>
        }
        <li>{appointment?.remark && 
          <span>
            <NotificationOutlined style={{ color: "red" }} /> 客户备注：<span style={{ textDecoration: "underline red", marginRight: "6px" }}>{appointment.remark}</span>
          </span>}
        </li>
        <li>
          <PayCircleOutlined /> 原价：{amount/100}；应收：{realAmount / 100}；实收：<span style={{ color: "red", fontWeight: "bold" }}>{realPayAmount / 100}</span>； 
          {(payStatus !== 2 && goodsType !== "TIMES_CARD") && <a onClick={() => updateOrder(sellerRemark, orderId, shopId)}><DoubleRightOutlined /> 完成收款</a>}
        </li>
        
      </ul>
      {/* <TwoStepFlow goodsCode={goodsCode} orderStatus={orderStatus} /> */}
      <Flex gap={8} vertical={true}>
        {/* <PayFlow order={order} /> */}
        <TwoStepFlow order={order} onFlowChange={onFlowChange} times={goods?.goodsInfo?.times} />
      </Flex>
    </Card>
  );
};

export default OrderCard;
